import { z } from 'zod';

export const registerUserFormSchema = z.object({
  firstName: z
    .string()
    .min(1, 'First name is required')
    .min(3, 'First name must be at least 3 characters'),
  lastName: z
    .string()
    .min(1, 'Last name is required')
    .min(2, 'Last name must be at least 2 characters'),
  email: z
    .string()
    .min(1, 'Email is required')
    .check(z.email({ error: 'Invalid email address' })),
});

export type RegisterUserFormSchema = z.infer<typeof registerUserFormSchema>;
